import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-video-lecture',
  templateUrl: './video-lecture.component.html',
  styleUrls: ['./video-lecture.component.scss']
})
export class VideoLectureComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }


  /**
   * View seleted course. Take user to video main page
   * //TODO Need to pass video object later
   */
  viewCourse(){
    this.router.navigate(['video']);
  }

}
